import { styled, createTheme, responsiveFontSizes } from '@mui/material/styles'
import InputBase from '@mui/material/InputBase'
import TextField from '@mui/material/TextField'
import Slider from '@mui/material/Slider'
import { Button } from '@mui/material'
import MuiAccordion from '@mui/material/Accordion'
import GothamFont from './gotham-book-webfont.woff'

export const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
    ({ theme }) => ({
        border: '1px solid grey',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
    })
)

export var customTheme = createTheme({
    palette: {
        primary: {
            main: '#20b2aa',
        },
    },
    '&:hover': {
        backgroundColor: '#0069d9',
        borderColor: '#0062cc',
        boxShadow: 'none',
    },
    typography: {
        fontFamily: `${GothamFont} , Arial`,
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
            @font-face {
              font-family: ${GothamFont} , Arial;
              font-style: normal;
              src: local('Gotham'), local('Gotham'), url(${GothamFont}) format('woff');
              unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
            }
          `,
        },
    },
})

customTheme = responsiveFontSizes(customTheme)

export const CountryInput = styled(InputBase)(({ theme }) => ({
    '& .MuiInputBase-input': {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}))

export const TextFieldInput = styled(TextField)(({ theme }) => ({
    '& .MuiInputBase-input': {
        borderRadius: 4,
        color: '#4B4B4B',
        fontWeight: '600',
        fontSize: '1.7em',
        paddingTop: '15px',
        maxHeight: '1em',
    },
    '& .css-1fe4141 .MuiInputBase-input': {
        borderRadius: 4,
        color: '#4B4B4B',
        fontWeight: '600',
        fontSize: '1.7em',
        paddingTop: '15px',
        maxHeight: '1em',
    },
    '& .css-17ygoij-MuiInputBase-root-MuiFilledInput-root:after': {
        borderBottom: '3px solid #FF9E92',
    },
    '& .css-17ygoij-MuiInputBase-root-MuiFilledInput-root:before': {
        borderBottom: '3px solid #FF9E92',
    },
    '& .css-17ygoij-MuiInputBase-root-MuiFilledInput-root': {
        borderBottom: '3px solid #FF9E92',
    },
    '& .css-10xr5ej::after': {
        borderBottom: '3px solid #FF9E92',
    },
    '& .css-10xr5ej::before': {
        borderBottom: '3px solid #FF9E92',
    },
    '& .css-10xr5ej': {
        borderBottom: '3px solid #FF9E92',
    },
    '& .css-2bxn45': {
        backgroundColor: theme.palette.background.paper,
    },
    '& .css-10botns-MuiInputBase-input-MuiFilledInput-input': {
        backgroundColor: theme.palette.background.paper,
    },
    '& .MuiInputBase-input-MuiFilledInput-input': {
        backgroundColor: theme.palette.background.paper,
    },
    '& .css-10xr5ej.Mui-focused': {
        backgroundColor: '#FCEFEC',
    },
    '& .Mui-focused': {
        backgroundColor: '#FCEFEC',
    },
    '& .css-1qq9pb7-MuiStack-root': {
        marginTop: '0 !important',
    },
}))

export const DataSlider = styled(Slider)({
    color: '#FF9E92',
    height: 10,
    '& .MuiSlider-track': {
        border: '1px solid #FFEFEC',
    },
    '& .MuiSlider-thumb': {
        height: 27,
        width: 27,
        border: '2px solid currentColor',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&:before': {
            display: 'none',
        },
    },
    '& .MuiSlider-rail': {
        color: '#FFEFEC',
        opacity: 1,
    },
})

export const ColorButton = styled(Button)(({ theme }) => ({
    backgroundColor: 'white',
    color: '#EA5532',
    '&:hover': {
        color: 'white',
        backgroundColor: '#891515',
    },
}))
